export default "__VITE_ASSET__BREFMHns__"